import React from 'react';
import { Link } from 'react-router';

var EmptyCat = React.createClass({
  render: function(){
    return(
      <div className="AppAdmin">
        <div className="table-cell">
          <h1 className="emptyHeadline">Раздел пуст</h1>
          <div className="List">
            <Link className="block" to="/admin/">Назад</Link>
          </div>
        </div>
      </div>
    );
  }
});

export default EmptyCat;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/List/components/EmptyCat/index.jsx
 **/